import React, { Fragment } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import Price from "components/Price/Price"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import ProductRowCartAction from "components/Product/ProductRowCartAction"
import ListActions from "components/Product/ProductRowListAction"
import { Label, Icon } from "semantic-ui-react";
import shop from "shop/shop"
import OrderModel   from "shop/OrderModel";
import Responsive                                                from "react-responsive"


let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0
let articleOpen = 0		
console.log("PRODUCTS ROW: ", shop.cart.products)
const ProductRowDefault = observer( ( { product, onChange, list, cart } ) => {
  let pageSize = 20
  let start = current
  current = current + pageSize
  /*shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
    .then( res => {
      console.log( "FROM API", { res } )
      orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
      openPositions = []
      // find orders with Open Positions
      let orderOpen = orders.filter( order => {
      return order.positions.filter( product => {
        let hasOpen = product.open && product.open !== 0
        if ( hasOpen ) {
        openPositions.push( product )
        console.log("PRODUCT: ",product)
        console.log("OPENPOSITIONS: ",openPositions)
        if(openPositions){
          if(openPositions.length > 0){
            for(let i = 0; openPositions.length > i;i++){
              if(openPositions[i].article_nr == product.article_nr){
                articleOpen = 1
              }
            }
          }
          
        }
        }
        return hasOpen
      } ).length
      } )
      
    } )
    console.log("HASOPEN:", openPositions)
    console.log("HASOPEN:", product.article_nr)
    let articleOpen = 0		
		if(openPositions){
			if(openPositions.length > 0){
				console.log("HASOPEN:", openPositions[0].article_nr)
				console.log("HASOPEN:", product.article_nr)
				for(let i = 0; openPositions.length > i;i++){
					if(openPositions[i].article_nr == product.article_nr){
						console.log("hasopenpassig")
						articleOpen = 1
					}
				}
			}
			
		}*/
    let hasCustomVE = false
    if(product.extras){
      hasCustomVE = product.extras.Z_Verpackungseinheit_Anzahl && product.extras.Z_Verpackungseinheit_Anzahl !== "1"
    }
   
  return (
    <Fragment>
        <tr>

        <Responsive minWidth={790}><td>
          {cart ? <ProductRowCartAction cart={cart} product={product}/> : null}
        </td>
        <td>
					<img
						className="db center"
						src={product.img_src_small}
						alt=""/>
			</td> 
        </Responsive>
        <td>
          <Link to={`/product/${product.map_id}`}>
            <strong>{product.article_nr}</strong> <br/>
            <span className="product-title">{product.title}</span>
          </Link>
        </td>
        <Responsive maxWidth={790}><td>
					<img
						className="db center"
						height="34"
            width={25}
						src={product.img_src_small}
						alt=""/>
			</td>   
      </Responsive>
        <Responsive minWidth={790}><td><span className=""></span></td></Responsive>
        <Responsive minWidth={790}><td>
          <Price>{product.price}</Price>

        </td></Responsive>
        <Responsive minWidth={790}><td>
          <div>{product.unit_multi} {hasCustomVE ? translate( "VE" ) : translate( "Stück" )} </div>
          <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
        </td></Responsive>
        {/*<td><Price>{product.price * product.unit_multi}</Price></td>*/}
        {/*<td></td>*/}
        <td>

          <div className="tr">
            <div><Price>{product.price * product.count * product.unit_multi}</Price></div>
            <div>{product.unit_multi * product.count} {translate( "Stück" )}</div>
          </div>
        </td>
        
        <Responsive minWidth={790}><td className="tr">
          <ProductCount product={product} onChange={onChange}/>
        </td></Responsive>
        
        {list && <td>
          <div className="fr"><ListActions list={list} product={product}/></div>
        </td>}
      </tr>
      <Responsive maxWidth={790}>
        <tr>
        <td className="tl">
            <ProductCount product={product} onChange={onChange}/>
          </td>
          <td className="db center" >
          {product.stock == 0 && <div><Icon title="Ausverkauft" className="red truck icon"></Icon></div>}
			    {product.stock != 0 && product.stock <= 3 && <div><Icon title="Wenige auf Lager" className="yellow truck icon"></Icon></div>}
			    {product.stock > 3 && <div><Icon title="Auf Lager" className="green truck icon"></Icon></div>}  
          </td>
          <td style={{ textAlign: "right"}}>
            {cart ? <ProductRowCartAction cart={cart} product={product}/> : null}
          </td>

        </tr>
      </Responsive>
      </Fragment>
  )
} )
export default ProductRowDefault

ProductRowDefault.propTypes = {
  index   : PropTypes.any,
  list    : PropTypes.object,
  cart    : PropTypes.object,
  onChange: PropTypes.func,
  product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Product/ProductRowDefault.js